if (!window.minoGymNavigationReady) {
window.minoGymNavigationReady = true;
window.addEventListener('click', (event) => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (!document.querySelector('.mino-gym')) return;
  const link = event.target.closest('a[href]');
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
  const destination = new URL(link.href, window.location.href);
  const current = new URL(window.location.href);
  if (destination.origin !== current.origin || destination.pathname !== current.pathname) return;
  if (destination.searchParams.get('view') === current.searchParams.get('view')) return;
  if (!destination.searchParams.has('view') && !current.searchParams.has('view')) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign(destination.href);
}, true);
}
